import styles from "./profile.module.scss";
import { useAcceptedPatientNote } from "@/api/patientNote";
import * as Sentry from "@sentry/react";
import { Loading } from "@medoma/components/Loading/Loading";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { NavCard } from "@/routes/profile/navCard";
import { useLingui } from "@lingui/react/macro";
import { SecondaryNavCard } from "./secondaryNavCard";
import { knownFeatureFlagsSchema, useFeatureFlag } from "@/api/featureFlags";
import { Heading } from "@medoma/components/Heading/Heading";
import { Text } from "@medoma/components/Text/Text";
import { Trans } from "@lingui/react/macro";
import { usePatient } from "@/api/patient";
import InformationIcon from "@medoma/components/icons/InformationIcon";
import RatingStarIcon from "@medoma/components/icons/RatingStarIcon";
import { getPatientFullName } from "@medoma/models/patients";

export const Profile = () => {
  const {
    data: acceptedPatientNote,
    isPending,
    isError,
    error,
  } = useAcceptedPatientNote();

  const { data: carePatientNote } = useFeatureFlag(
    knownFeatureFlagsSchema.enum.CarePatientNote,
  );

  const {
    data: patient,
    isPending: isPendingPatient,
    isError: isErrorPatient,
    error: errorPatient,
  } = usePatient();

  const { t } = useLingui();
  if (isPending || isPendingPatient) {
    return <Loading message={t`Hämtar information om din vård`} />;
  }

  if (isError || isErrorPatient) {
    if (isError) {
      Sentry.captureException(error);
    } else {
      Sentry.captureException(errorPatient);
    }
    return (
      <ErrorMessage message={t`Kunde inte hämta information om din vård`} />
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.navigationCards}>
        {acceptedPatientNote && carePatientNote ? (
          <NavCard
            link={{
              to: "/profile/patientNotes",
              title: t`Vårdsammanfattning`,
              description: t`Personlig information utifrån din journal`,
            }}
          />
        ) : null}
        <NavCard
          link={{
            to: "/profile/patientGuide",
            title: t`Så vårdas du`,
            description: t`Praktisk information från din vårdgivare`,
          }}
        />
        <SecondaryNavCard
          icon={<InformationIcon />}
          link={{
            to: "/profile/about",
            title: t`Om appen`,
          }}
        />
        <SecondaryNavCard
          icon={<RatingStarIcon />}
          link={{
            to: "/profile/review",
            title: t`Utvärdering`,
          }}
        />
      </div>
      <div className={styles.patientInfo}>
        <Heading level="h2" size="h4">
          <Trans>Inloggad som</Trans>
        </Heading>
        <Text element="div">{getPatientFullName(patient.name)}</Text>
      </div>
    </div>
  );
};
